__turbopack_context__.v({
  "grid": "glance-module__E0w6MW__grid",
  "tile": "glance-module__E0w6MW__tile",
});
